import {ShiftEvent} from '@hconnect/common/types'

export const getEventsByCategory = (events: ShiftEvent[]): Record<string, ShiftEvent[]> => {
  return events.reduce((acc, event) => {
    const noCategory = event.category ?? 'noCategory'
    acc[noCategory] = acc[noCategory] || []
    acc[noCategory].push(event)
    return acc
  }, {})
}
